import { SortOptions } from "../pages/PropertiesList/enum";

const getDistanceFromLatLonInKm = (
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
) => {
  var R = 6371; // Radius of the earth in km
  var dLat = deg2rad(lat2 - lat1); // deg2rad below
  var dLon = deg2rad(lon2 - lon1);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c; // Distance in km
  return d; // distance returned
};

const deg2rad = (deg: number) => {
  return deg * (Math.PI / 180);
};

const findPropertyByNeighborhood = (
  propertyList: Array<any> = [],
  neighborhood: any
) => {
  if (!neighborhood) return propertyList[0];

  const filteredProperties = propertyList.filter((property) => {
    return property?.address?.neighborhood === neighborhood;
  });

  return filteredProperties ? filteredProperties[0] : propertyList[0];
};

const sortByDistance = (
  propertyList: Array<any> = [],
  latitude: number,
  longitude: number
) => {
  try {
    for (let i = 0; i < propertyList.length; i++) {
      let distance = getDistanceFromLatLonInKm(
        latitude,
        longitude,
        propertyList[i]?.address?.latitude,
        propertyList[i]?.address?.longitude
      );
      propertyList[i].distance = distance;
    }

    return propertyList.sort((a, b) => {
      return a.distance - b.distance;
    });
  } catch (e) {
    return propertyList;
  }
};

const sortPropertiesByNeighborhood = (
  propertiesList: Array<any> = [],
  selectedNeighborhood: any
) => {
  if (!selectedNeighborhood) return propertiesList;

  return propertiesList.sort((a: any, b: any) => {
    return a?.address?.neighborhood === selectedNeighborhood
      ? -1
      : b?.address?.neighborhood === selectedNeighborhood
      ? 1
      : 0;
  });
};

const sortPropertiesByRank = (
  propertiesList: Array<any> = [],
  selectedNeighborhood: any
) => {
  if (!selectedNeighborhood) return propertiesList;
  const filteredProperties = propertiesList.filter(
    (property) => property?.address?.neighborhood === selectedNeighborhood
  );
  if (!filteredProperties || filteredProperties.length === 0)
    return propertiesList;
  propertiesList.splice(0, filteredProperties.length);
  const sortedProperties = filteredProperties.sort((a, b) => b.rank - a.rank);
  return [...sortedProperties, ...propertiesList];
};

const findTheNeighborhoodWithMoreProperties = (
  propertiesList: Array<any> = []
) => {
  const property = propertiesList
    .sort(
      (a, b) =>
        propertiesList.filter(
          (v) => v?.address?.neighborhood === a?.address?.neighborhood
        ).length -
        propertiesList.filter(
          (v) => v?.address?.neighborhood === b?.address?.neighborhood
        ).length
    )
    .pop();

  return property?.address?.neighborhood;
};

const sortByPrice = (propertyList: Array<any> = [], orderBy: SortOptions) => {
  return propertyList.sort((a, b) => {
    return orderBy === SortOptions.HIGHEST_PRICE
      ? b.rent_value - a.rent_value
      : a.rent_value - b.rent_value;
  });
};

export const sortProperties = (
  propertiesList: Array<any> = [],
  selectedNeighborhood: any,
  selectedCondominium: any,
  sortPropertiesBy?: SortOptions
) => {
  if (selectedNeighborhood) {
    const firstProperty = findPropertyByNeighborhood(
      [...propertiesList],
      selectedNeighborhood
    );
    const sortedByDistance = sortByDistance(
      [...propertiesList],
      firstProperty?.address?.latitude,
      firstProperty?.address?.longitude
    );
    const sortedByByNeighborhood = sortPropertiesByNeighborhood(
      sortedByDistance,
      selectedNeighborhood
    );
    const sortedByRank = sortPropertiesByRank(
      sortedByByNeighborhood,
      selectedNeighborhood
    );
    return sortedByRank;
  } else if (selectedCondominium) {
    return [...propertiesList];
  } else {
    const initialNeighborhood = findTheNeighborhoodWithMoreProperties([
      ...propertiesList,
    ]);
    const firstProperty = findPropertyByNeighborhood(
      [...propertiesList],
      initialNeighborhood
    );
    const sortedByDistance = sortByDistance(
      [...propertiesList],
      firstProperty?.address?.latitude,
      firstProperty?.address?.longitude
    );
    const sortedByByNeighborhood = sortPropertiesByNeighborhood(
      sortedByDistance,
      initialNeighborhood
    );
    const sortedByRank = sortPropertiesByRank(
      sortedByByNeighborhood,
      initialNeighborhood
    );

    return sortPropertiesBy && sortPropertiesBy !== SortOptions.NO_PREFERENCE
      ? sortByPrice(sortedByRank, sortPropertiesBy)
      : sortedByRank;
  }
};
